import React, { useEffect } from 'react';
import { Route, Redirect } from "react-router-dom";
import { publicRoutesPath } from './index';
import PublicLayout from '../Components/Layout/PublicLayout';
import LoginPage from '../Pages/Login';
import ForgotPassword from '../Pages/ForgotPassword';
import { useDispatch, useSelector } from 'react-redux';
import { requestgetcurrenctuser } from '../Store/User/action';
import FisrtUserPasswordSetup from '../Pages/PasswordSetUp';
import BiztantuLoader from '../Components/Loader';
import { getDefaultSelectedRoute } from '../Utility/rolepermissionHelper';

const PublicRoute = (props) => {
    const accessToken = localStorage.getItem('accessToken');
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);

    // isFetchingUser is true only while the GET /logged-in API call is in-flight.
    // Using this instead of `rolebasedData === null` prevents the loader
    // from getting stuck when the API fails (session expired) and rolebasedData
    // never moves off null.
    const isFetchingUser = useSelector(state => state?.owner?.isFetchingUser);

    const dispatch = useDispatch();

    useEffect(() => {
        if (accessToken && !currentUser) {
            dispatch(requestgetcurrenctuser(accessToken));
        }
    }, [accessToken, currentUser, dispatch]);

    const renderAuthenticatedRedirect = () => {
        // Show loader only while the API call is actively in-flight
        if (isFetchingUser) {
            <div className="after-login-loader">
            <BiztantuLoader open={true} />
        </div>
        }

        // Priority Check 1: If user must reset password, keep them strictly on /set-user-password
        if (currentUser?.resetPassword === true) {
            if (props.location?.pathname === publicRoutesPath.FIRST_USER_PASSWORD_SETUP) {
                return <Route exact path={publicRoutesPath.FIRST_USER_PASSWORD_SETUP} component={FisrtUserPasswordSetup} />;
            }
            return <Redirect to={publicRoutesPath.FIRST_USER_PASSWORD_SETUP} />;
        }

        // Priority Check 2: API call is done and user has set up password.
        // If we have permissions, redirect to the user's first allowed route.
        if (specificRolePermission) {
            const targetRoute = getDefaultSelectedRoute(specificRolePermission);
            return <Redirect to={targetRoute} />;
        }

        // No permissions and not fetching — render login page (handles post-logout state)
        return <Route exact path={publicRoutesPath.LOGIN} component={LoginPage} />;
    };

    return (
        <PublicLayout location={props.location}>
            {accessToken ? (
                renderAuthenticatedRedirect()
            ) : (
                <Route exact path={publicRoutesPath.LOGIN} component={LoginPage} />
            )}
            <Route exact path={`${publicRoutesPath?.FIRST_USER_PASSWORD_SETUP}`} component={FisrtUserPasswordSetup} />
            <Route exact path={publicRoutesPath.FORGOTPASSWORD} component={ForgotPassword} />
        </PublicLayout>
    );
};

export default PublicRoute;